{
  "name": "up.web.agent.checkout",
  "version": "1.3.19",
  "repository": "https://github.com/uplift-inc/up.web.agent.checkout.git",
  "license": "MIT",
  "devDependencies": {
    "@parcel/transformer-sass": "^2.7.0",
    "@swc/core": "^1.2.118",
    "@swc/jest": "^0.2.12",
    "@testing-library/jest-dom": "^5.16.5",
    "@testing-library/preact": "^2.0.1",
    "@testing-library/preact-hooks": "^1.1.0",
    "@types/dompurify": "^2.3.3",
    "@types/jest": "^27.0.2",
    "@types/jest-axe": "^3.5.3",
    "@types/react": "^17.0.24",
    "@types/react-dom": "^17.0.9",
    "@types/redux-mock-store": "^1.0.3",
    "@types/styled-components": "^5.1.14",
    "@types/uuid": "^8.3.1",
    "autoprefixer": "^10.4.0",
    "buffer": "^6.0.3",
    "jest": "^27.4.3",
    "jest-axe": "^5.0.1",
    "jest-transform-stub": "^2.0.0",
    "miragejs": "^0.1.43",
    "parcel": "^2.7.0",
    "postcss-modules": "^4.3.0",
    "pre-commit": "^1.2.2",
    "preact-cli-plugin-env-vars": "^1.2.1",
    "prettier": "2.4.1",
    "process": "^0.11.10",
    "redux-mock-store": "^1.5.4",
    "typescript": "^4.4.3",
    "typescript-plugin-css-modules": "^4.2.2"
  },
  "peerDependencies": {
    "postcss": "^8.4.12"
  },
  "dependencies": {
    "@babel/runtime": "^7.15.4",
    "@reduxjs/toolkit": "^1.6.1",
    "axios": "^1.11.0",
    "dompurify": "^3.1.3",
    "eslint-config-airbnb": "^18.2.1",
    "follow-redirects": "^1.14.9",
    "i18next": "^21.1.1",
    "minimist": "^1.2.6",
    "node-forge": "^1.3.0",
    "preact": "^10.5.14",
    "react": "^17.0.2",
    "react-device-detect": "^2.2.3",
    "react-dom": "^17.0.2",
    "react-i18next": "^11.12.0",
    "react-plaid-link": "^3.3.2",
    "react-redux": "^7.2.5",
    "redux": "^4.1.1",
    "redux-thunk": "^2.3.0",
    "styled-components": "^5.3.1",
    "up-ops-web-shared-components": "^12.3.7",
    "up.lib.js.swissknife": "https://51590906:ghs_6voOr3cWB9lcDvQmkyrAxT8yovVPWJ0cvybO@github.com/uplift-inc/up.lib.js.swissknife.git#v3.0.16",
    "up.lib.js.xhrio": "https://51590906:ghs_6voOr3cWB9lcDvQmkyrAxT8yovVPWJ0cvybO@github.com/uplift-inc/up.lib.js.xhrio.git",
    "uuid": "^9.0.0"
  },
  "scripts": {
    "start": "parcel src/index.html --port 2000",
    "dev": "rm -rf dist/* && rm -rf .parcel-cache/* && parcel src/index.html --port 2000",
    "build": "parcel build src/index.html",
    "format": "prettier --write src",
    "test": "jest",
    "test-watch": "jest --watch",
    "type-check": "tsc --noEmit --skipLibCheck"
  },
  "alias": {
    "react": "preact/compat",
    "react-dom": "preact/compat",
    "preact/jsx-dev-runtime": "preact/jsx-runtime",
    "react/jsx-runtime": "preact/jsx-runtime"
  },
  "pre-commit": [
    "format",
    "test",
    "build",
    "type-check"
  ],
  "browserslist": "defaults",
  "resolutions": {
    "follow-redirects": "^1.14.9",
    "minimist": "^1.2.6",
    "postcss": "^8.4.12",
    "moment": "^2.29.4",
    "terser": "^5.14.2",
    "minimatch": "^3.0.5",
    "json5": "^2.2.2",
    "loader-utils": "^3.2.1",
    "braces": "^3.0.3",
    "ws": "^8.17.1",
    "nth-check": "^2.0.1",
    "path-to-regexp": "^1.8.0",
    "@babel/traverse": "^7.23.2",
    "msgpackr": "^1.10.1",
    "lodash.pick": "^4.4.0",
    "semver": "^7.6.3",
    "cross-spawn": "^7.0.6"
  }
}
